import { Button, Typography } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { anonymousSignin } from '../actions/userActions';
import styles from '../css/bg.module.css';
import { userSignedIn } from '../selectors';

const Signup = (props) => {
    const dispatch = useDispatch();
    const signedIn = useSelector((state) => userSignedIn(state));

    const { from } = props.location.state || { from: { pathname: '/liquors' } };

    if (signedIn) {
        return <Redirect to={from} />;
    }

    const handleRegister = () => {
        props.history.push({
            pathname: '/register',
            state: {
                from,
            },
        });
    };
    return (
        <div className={styles.bg}>
            <div className={styles.center}>
                <Typography variant="h1" style={{ marginBottom: '2.5rem' }}>
                    Sign Up
                </Typography>
                <div className={styles.options_container}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            dispatch(anonymousSignin());
                        }}
                    >
                        Sign in as Guest{' '}
                    </Button>
                    <div className={styles.text_block}>
                        <p>
                            Your cart will be saved locally, but you'll need to
                            fill out your information when checking out.
                        </p>
                        <p>
                            You can link the guest account to a real account any
                            time in your profile page.
                        </p>
                    </div>
                </div>
                <Typography variant="h5">or</Typography>
                <div className={styles.options_container}>
                    <Button variant="contained" onClick={handleRegister}>
                        Register for an Account
                    </Button>
                    <div className={styles.text_block}>
                        <p>
                            Your cart and check out information will be saved in
                            the cloud.
                        </p>
                        <Link
                            className={styles.link}
                            to={{
                                pathname: '/signin',
                                state: {
                                    from,
                                },
                            }}
                        >
                            Have an account? Sign in.
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Signup;
